import { SizeProp } from '@fortawesome/fontawesome-svg-core';
import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './ToggleIcon.scss';

interface ToggleIconProps {
    idText?: string;
    icon: IconDefinition;
    title?: string;
    disabled?: boolean;
    checked?: boolean;
    size?: SizeProp;
    activeColor?: string;
    inactiveColor?: string;
    onChange: (newState: boolean) => void;
}

const ToggleIcon = (props: ToggleIconProps) => {
    const key =
        props.idText !== undefined ? props.idText : Date.now().toString();
    const uniqueId = 'toggle-icon-' + key;

    const computeColor = () => {
        const isActive = !props.disabled && !!props.checked;
        const isActiveColorProvided = !!props.activeColor;
        const isInactiveColorProvided = !!props.inactiveColor;

        return isActive
            ? isActiveColorProvided
                ? props.activeColor
                : '#000000'
            : isInactiveColorProvided
            ? props.inactiveColor
            : isActiveColorProvided
            ? props.activeColor
            : '#000000';
    };

    const computeOpacity = () => {
        const isActive = !props.disabled && !!props.checked;
        const isInactiveColorProvided = !!props.inactiveColor;

        return isActive || isInactiveColorProvided ? 1 : 0.5;
    };

    return (
        <span
            title={props.title ?? ''}
            className="toggle-icon-container"
            onClick={() => {
                if (!props.disabled) {
                    props.onChange(!props.checked);
                }
            }}>
            <FontAwesomeIcon
                size={props.size ?? '1x'}
                opacity={computeOpacity()}
                color={computeColor()}
                id={uniqueId}
                icon={props.icon}
                className="tooltip-icon"
                cursor={!!props.disabled ? 'not-allowed' : 'pointer'}
            />
        </span>
    );
};

export default ToggleIcon;
